import React, { ReactElement } from "react";
import { WidgetComponentRenderProps } from "../WidgetComponentsMapping";
import { wrapAsHtml } from "@utils/ComponentUtils";
import { adjustHtmlLinks } from "@utils/StringUtils";

const HtmlWidget = (props: WidgetComponentRenderProps): ReactElement => {
  const { dataAndConfigs, widget } = props;
  const config = JSON.parse(widget.options)?.config ?? {};
  /* Set style on the html contents on widget options (extInfo)
    {
      "config": {
        "style": {
          "color": "red",
          "fontSize": "32px",
          "textAlign": "center"
        }
      }
    }
   */
  const mergedConfigs = { ...config, ...dataAndConfigs };

  // Adjust internal links in HTML content
  const htmlContent = typeof dataAndConfigs.data === 'string'
    ? adjustHtmlLinks(dataAndConfigs.data)
    : dataAndConfigs.data;

  return (
    <div
        className="html-widget"
        role="region"
        aria-label={config.className}
        {...mergedConfigs}
    >
      {wrapAsHtml(htmlContent as string)}
    </div>
  );
};

export default HtmlWidget;
